if (!customElements.get('cart-item-slider')) {
  class CartItemSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.currentSlide = 0;
      this.totalSlides = 0;
    }

    connectedCallback() {
      this.#initializeSlider();
    }

    disconnectedCallback() {
      this.#destroySwiper();
    }

    #initializeSlider() {
      const swiperContainer = this.querySelector('.cart-item-slider__swiper');
      const slides = this.querySelectorAll('.cart-item-slider__slide');
      const progressBar = this.querySelector('.cart-item-slider__progress-fill');
      
      if (!swiperContainer || slides.length <= 1) return;

      this.totalSlides = slides.length;

      // Import Swiper if not already available
      if (typeof Swiper === 'undefined') {
        this.#loadSwiper();
        return;
      }

      this.#createSwiper(swiperContainer, progressBar);
    }

    #loadSwiper() {
      // Load Swiper CSS
      if (!document.querySelector('link[href*="swiper"]')) {
        const swiperCSS = document.createElement('link');
        swiperCSS.rel = 'stylesheet';
        swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(swiperCSS);
      }

      // Load Swiper JS
      const swiperScript = document.createElement('script');
      swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperScript.onload = () => {
        const swiperContainer = this.querySelector('.cart-item-slider__swiper');
        const progressBar = this.querySelector('.cart-item-slider__progress-fill');
        this.#createSwiper(swiperContainer, progressBar);
      };
      document.head.appendChild(swiperScript);
    }

    #createSwiper(swiperContainer, progressBar) {
      if (!swiperContainer) return;
      
      // Destroy existing instance if any
      this.#destroySwiper();

      this.swiper = new Swiper(swiperContainer, {
        loop: this.totalSlides > 1,
        autoHeight: false,
        grabCursor: true,
        observer: true,
        observeParents: true,
        touchEventsTarget: 'container',
        preventInteractionOnTransition: true,
        on: {
          slideChange: (swiper) => {
            this.currentSlide = swiper.realIndex;
            this.#updateProgress(progressBar);
          }
        }
      });

      this.#updateProgress(progressBar);
    }

    #destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    #updateProgress(progressBar) {
      if (!progressBar || this.totalSlides <= 1) return;
      
      const progress = ((this.currentSlide + 1) / this.totalSlides) * 100;
      progressBar.style.width = `${progress}%`;
    }

    // Public method to reinitialize (called after cart updates)
    reinitialize() {
      this.#destroySwiper();
      this.#initializeSlider();
    }
  }

  customElements.define('cart-item-slider', CartItemSlider);
}
